import React from "react";
import AboutNavBar from "../components/AboutNavBar";
import ContactUsForm from "../components/ContactUsForm";
import Footer from "../components/Footer";
import RenderLinks from "../components/RenderLinks";
import { Helmet } from "react-helmet-async";

function ContactUs() {
  const siteUrl = "https://microcodesoftware.com"; // Base URL
  const pagePath = "/contact"; // Dynamic path if needed
  return (
    <div>
      <Helmet>
        <title>
          Contact Microcode Software | Software & Marketing Experts in India
        </title>
        <meta
          name="description"
          content="Have questions or need a custom solution? Contact Microcode Software – a top software development and digital marketing company in India. Let’s discuss how we can help grow your business."
        />
        <meta
          name="keywords"
          content="Contact Microcode Software, Software development company India contact, Digital marketing agency India contact, Get in touch software company, Business inquiry Microcode, Tech support Microcode Software, Marketing solutions India"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${siteUrl}${pagePath}`} />
      </Helmet>
      <RenderLinks />
      <AboutNavBar />
      <ContactUsForm />
      <Footer />
    </div>
  );
}

export default ContactUs;
